import {adapter} from "./adapter";

export const servicioObtenerConcesionarios = (ciudad) => {
    // const endPoint = `/api/concesionarios/1/1-3/2/${ciudad}`;
    const endPoint = `/api/repuestos/concesionarios/1/${ciudad}`;
    return adapter(endPoint, "GET", null);
};

export const servicioObtenerCiudades = () => {
    // const endPoint = `/api/ciudades/1/1-3/2`
    const endPoint = `/api/repuestos/ciudades/1`
    return adapter(endPoint, "GET", null);
};